export default __webpack_public_path__ + "static-bigflip/media/icon-step-4.9c0ff74a.png";